import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "DEBUG"];
import { Children, cloneElement, Fragment, isValidElement } from 'react';
import TooltipPopup from "./TooltipPopup";
import useTooltip from "./useTooltip";

/**
 *
 * @deprecated This tooltip wrapper is deprecated. Please refer to the Tooltip in "@compass.ui/v2"
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    DEBUG = _ref.DEBUG,
    tooltipProps = _objectWithoutProperties(_ref, _excluded);
  var child = Children.only(children);
  if (! /*#__PURE__*/isValidElement(child)) {
    throw new Error("You must provide a valid child for the tooltip. Otherwise, there's no tooltip to show");
  }
  var _useTooltip = useTooltip({
      onMouseEnter: child.props.onMouseEnter,
      onMouseMove: child.props.onMouseMove,
      onMouseLeave: child.props.onMouseLeave,
      onFocus: child.props.onFocus,
      onBlur: child.props.onBlur,
      onKeyDown: child.props.onKeyDown,
      onMouseDown: child.props.onMouseDown,
      // @ts-expect-error (TODO: Property 'ref' does not exist on type 'ReactElement<any, string | JSXElementConstructor<any>> | ReactPortal')
      ref: child.ref || null,
      DEBUG: DEBUG
    }),
    _useTooltip2 = _slicedToArray(_useTooltip, 2),
    trigger = _useTooltip2[0],
    tooltip = _useTooltip2[1];
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/cloneElement(child, trigger), /*#__PURE__*/_jsx(TooltipPopup, _objectSpread(_objectSpread({}, tooltip), tooltipProps))]
  });
};
export default Tooltip;